import React from 'react';
import Spinner from '@atlaskit/spinner';
import { Form, Formik } from 'formik';

import { Button } from '@/components';
import Field from '@/components/forms/Field';
import UserService from '@/lib/UserService';

import styles from '../styles.module.scss';

interface Props {
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setInProgress: React.Dispatch<React.SetStateAction<boolean>>;
  setShowCheck: React.Dispatch<React.SetStateAction<boolean>>;
  setError: React.Dispatch<React.SetStateAction<string>>;
}

interface ManualRegistrationForm {
  email: string;
}

const ManualRegistrationInitialValues = {
  email: '',
};

const ActivateViaEmail = ({ loading, setLoading, setInProgress, setShowCheck, setError }: Props) => {
  const handleManualRegistration = async (values: ManualRegistrationForm) => {
    setLoading(true);
    const response = await UserService.registerUser(values?.email);
    if (response && response.inProgress) {
      setInProgress(true);
      setError('Your account registration may not yet be complete.');
    }
    setShowCheck(true);
    setLoading(false);
  };

  return (
    <>
      <span>Please enter your email to start the activation process.</span>
      <Formik onSubmit={handleManualRegistration} initialValues={ManualRegistrationInitialValues}>
        <Form>
          {loading ? (
            <div className={styles.spinner}>
              <Spinner size="large" />
            </div>
          ) : (
            <>
              <Field label="Email" type="email" name="email" formik required />
              <Button type="submit">Register your account</Button>
            </>
          )}
        </Form>
      </Formik>
    </>
  );
};

export default ActivateViaEmail;
